// The single rule for "is this event/participation virtual (online)?", mirroring
// public.is_virtual_location() in the database: a virtual event has no location
// (location_id NULL). Never test a city name for virtual-ness.

export function isVirtualLocationId(id: number | null | undefined): boolean {
  return id == null;
}

/** What the UI shows as the location of a virtual event. */
export const VIRTUAL_LOCATION = {
  id: null,
  location_name: "Virtual",
  city: "Virtual",
  country: null,
  timezone: null,
  location_link: null,
  route_link: null,
} as const;

/** Looks up a location by id; a NULL (virtual) id yields VIRTUAL_LOCATION. */
export function locationOrVirtual<L>(
  map: Map<number, L>,
  id: number | null | undefined,
): L | typeof VIRTUAL_LOCATION | undefined {
  return id == null ? VIRTUAL_LOCATION : map.get(id);
}
